export default {
  params: ['totalContentsCost', 'isContentsCalc'],
  validate (contentsReplaceCost, { totalContentsCost }) {
    return {
      required: true,
      valid: contentsReplaceCost &&
        (Number(contentsReplaceCost) >= Number(this.constants.CONTENTS_REPLACE_COST_MIN)) &&
        (Number(contentsReplaceCost) <= Number(this.constants.CONTENTS_REPLACE_COST_MAX)) &&
        (Number(contentsReplaceCost) >= Number(totalContentsCost)),
    };
  },
  message (fieldName, { _value_: contentsReplaceCost, totalContentsCost, isContentsCalc = false }) {
    if (!contentsReplaceCost && isContentsCalc) return `This calculated figure should be between ${this.constants.CONTENTS_REPLACE_COST_MIN} & ${this.constants.CONTENTS_REPLACE_COST_MAX}.`;
    if (!contentsReplaceCost) return 'Please enter a number e.g. 10000.';

    if (Number(contentsReplaceCost) < Number(totalContentsCost)) return 'Please review related questions: The total value of all added items and personal possessions cannot exceed your total contents cover.';

    if ((Number(contentsReplaceCost) < Number(this.constants.CONTENTS_REPLACE_COST_MIN)) ||
      (Number(contentsReplaceCost) > Number(this.constants.CONTENTS_REPLACE_COST_MAX))) {
      if (isContentsCalc) {
        return `Please review & edit above calculator fields to make sure this total amount is between ${this.constants.CONTENTS_REPLACE_COST_MIN} & ${this.constants.CONTENTS_REPLACE_COST_MAX}`;
      } else {
        return `Please enter a number between ${this.constants.CONTENTS_REPLACE_COST_MIN} & ${this.constants.CONTENTS_REPLACE_COST_MAX}.`;
      }
    }
  },
  computesRequired: true,
};
